<template>
  <div class="books-details">
    <!-- 保证金汇款 -->
    <p class="box-title">保证金汇款</p>

    <div class="first-p">
      <div>
        <p>查询码：{{ props.stepInfo.query_code }}</p>
        <p>已申请： {{ props.stepInfo.days }}天</p>
        <p>办理人员：{{ props.stepInfo.approver }}</p>
        <p>
          受理时间：
          {{
            dayjs(props.stepInfo.processing_time * 1000).format("YYYY-MM-DD")
          }}
        </p>
      </div>
      <div>
        <p>当前状态：{{ props.stepInfo.status_text }}</p>
        <p>
          申请时间：{{
            dayjs(props.stepInfo.create_time * 1000).format("YYYY-MM-DD")
          }}
        </p>
        <p>
          办理时间：{{
            dayjs(props.stepInfo.handle_time * 1000).format("YYYY-MM-DD")
          }}
        </p>
      </div>
      <div>
        <p>
          预计领证日期：{{
            dayjs(props.stepInfo.grant_time * 1000).format("YYYY-MM-DD")
          }}
        </p>
      </div>
    </div>
    <div class="second-p">
      <p class="suggestion-title">办理意见：</p>
      <div class="suggestion-box">
        <p>{{ props.stepInfo.descr }}</p>
        
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

import { reactive, computed } from "vue";
// import { ElMessage } from 'element-plus'
import { ComponentSize, FormInstance, FormRules } from "element-plus";

import {
  Delete,
  Download,
  Plus,
  ZoomIn,
  Warning,
} from "@element-plus/icons-vue";

import { UploadFile } from "element-plus";

import dayjs from "dayjs";

const router = useRouter();

// const mydata = reactive({
//   size: "default",
//   queryCodeObj: {},
// });

const props = defineProps({
  stepInfo: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

// const props = defineProps({
//   path: {
//     type: String,
//     // default: "",
//   },
//   info: {
//     type: Object,
//     default: () => {
//       return {};
//     },
//   },
// });

// const submitForm = async (formEl: FormInstance | undefined) => {
//   if (!formEl) return
//   await formEl.validate((valid, fields) => {
//     if (valid) {
//       console.log('submit!')
//     } else {
//       console.log('error submit!', fields)
//     }
//   })
// }

// const resetForm = (formEl: FormInstance | undefined) => {
//   if (!formEl) return
//   formEl.resetFields()
// }

// const options = Array.from({ length: 10000 }).map((_, idx) => ({
//   value: `${idx + 1}`,
//   label: `${idx + 1}`,
// }))

// const handleRemove = (file) => {
//   console.log(file)
// }

// const handlePictureCardPreview = (file) => {
//   dialogImageUrl.value = file.url!
//   dialogVisible.value = true
// }

// const handleDownload = (file) => {
//   console.log(file)
// }
</script>

<style scoped lang="scss">
.books-details {
  width:343px;
  overflow: hidden;
  // border: 1px solid red;
  margin: 0 auto;
  // margin-top: 16px;
  padding: 20px 16px 40px 16px;
  background-color: #ffffff !important;
  border-radius: 8px;
  margin-bottom:40px;

  .box-title {
    font-size: 18px;
    font-weight: 700;
    color: #333333;
    margin-bottom: 20px;
  }
  .first-p {
    font-size: 14px;
    font-weight: 400;
    color: #000000a6;
    line-height: 34px;
  }
  .second-p {
    font-size: 14px;
    font-weight: 400;
    color: #000000a6;
    line-height: 22px;
    .suggestion-title {
      margin: 6px 0px;
    }
    .suggestion-box {
      width: 311px;
      padding: 16px;
      border: 1px solid #dcdee2;
      border-radius: 8px;
    }
  }
}
</style>